// extracted by mini-css-extract-plugin
export default {"registerPage":"register_registerPage__pmLIE","registerForm":"register_registerForm__GlmiK"};